import { apiClient } from './client';
import { API_PRX } from './endpoints';
import type { ApiResponse } from '@indipia/shared-types';
import type { CodeItem, InitData, SessionData, SubscriptionItem } from '../stores/appStore';

// ── GET /indipia/init ────────────────────────────────────────────────────────

interface InitRaw {
  studioId: number | null;
  studioStage: number | null;
  profileImgUrl: string | null;
  subscriptions: Array<{
    agentSubId: number;
    agentId: number;
    agentName: string;
    agentType: string;
    iconUrl: string | null;
    recommendTitle: string | null;
    recommendDesc: string | null;
    /** TM_AGENT.AGENT_ORDER — LeftNav·스튜디오 홈 메뉴 정렬용 */
    agentOrder: number | null;
    createdAt: string;
  }>;
  codes: Array<{
    codeGroupCode: string;
    codeValue: string;
    codeName: string;
    codeOrder: number;
  }>;
}

export async function fetchInit(): Promise<InitData> {
  const res = await apiClient.get<ApiResponse<InitRaw>>(`${API_PRX.INDIPIA}/init`);
  const d = res.data.data;

  const subscriptions: SubscriptionItem[] = (d.subscriptions ?? []).map((s) => ({
    agentSubId: s.agentSubId,
    agentId: s.agentId,
    agentName: s.agentName,
    agentType: s.agentType,
    iconUrl: s.iconUrl,
    recommendTitle: s.recommendTitle,
    recommendDesc: s.recommendDesc,
    agentOrder: s.agentOrder,
    createdAt: s.createdAt,
  }));

  const codes: CodeItem[] = (d.codes ?? []).map((c) => ({
    codeGroupCode: c.codeGroupCode,
    codeValue: c.codeValue,
    codeName: c.codeName,
    codeOrder: c.codeOrder,
  }));

  return {
    studioId: d.studioId,
    studioStage: d.studioStage,
    profileImgUrl: d.profileImgUrl,
    subscriptions,
    codes,
  };
}

// ── GET /member/auth/session ─────────────────────────────────────────────────

interface SessionRaw {
  memberId: number;
  loginId: string;
  memberName: string;
  masterYn: string;
  compId: number | null;
  compName: string | null;
  studioId: number | null;
  profileImgUrl: string | null;
  affiliationStatus: 'PENDING' | 'ACTIVE' | 'REJECTED' | 'RELEASED' | null;
}

export async function fetchSession(): Promise<SessionData> {
  const res = await apiClient.get<ApiResponse<SessionRaw>>(`${API_PRX.MEMBER}/auth/session`);
  return res.data.data;
}
